import React, { useMemo } from 'react';
import { LuChevronRight } from 'react-icons/lu';
import SafeIcon from '../../common/SafeIcon';

const STAGES = [
  { id: 'Lead', label: 'Lead', color: 'bg-gray-500' },
  { id: 'Qualified', label: 'Qualified', color: 'bg-blue-500' },
  { id: 'Proposal', label: 'Proposal', color: 'bg-yellow-500' },
  { id: 'Negotiation', label: 'Negotiation', color: 'bg-orange-500' },
  { id: 'Closed Won', label: 'Closed Won', color: 'bg-green-500' }
];

const ConversionFunnel = ({ opportunities }) => {
  const funnelData = useMemo(() => {
    const stageCounts = STAGES.map(stage => ({
      ...stage,
      count: opportunities.filter(opp => opp.stage === stage.id).length,
      value: opportunities
        .filter(opp => opp.stage === stage.id)
        .reduce((sum, opp) => sum + (parseFloat(opp.amount) || 0), 0)
    }));

    const maxCount = Math.max(...stageCounts.map(s => s.count), 1);

    return stageCounts.map((stage, index) => ({
      ...stage,
      percentage: (stage.count / maxCount) * 100,
      conversionRate: index > 0 && stageCounts[index - 1].count > 0
        ? (stage.count / stageCounts[index - 1].count) * 100
        : 100
    }));
  }, [opportunities]);

  const formatCurrency = (amount) => {
    if (amount >= 1000000) return `$${(amount / 1000000).toFixed(1)}M`;
    if (amount >= 1000) return `$${(amount / 1000).toFixed(0)}K`;
    return `$${amount}`;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Sales Funnel Conversion
      </h3>
      <div className="space-y-4">
        {funnelData.map((stage, index) => (
          <div key={stage.id}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center space-x-2">
                <span className="text-sm font-medium text-gray-700">
                  {stage.label}
                </span>
                {index > 0 && (
                  <span className="text-xs text-gray-500">
                    ({stage.conversionRate.toFixed(0)}% conversion)
                  </span>
                )}
              </div>
              <div className="text-right">
                <span className="text-sm font-semibold text-gray-900">
                  {stage.count}
                </span>
                <span className="text-xs text-gray-500 ml-2">
                  {formatCurrency(stage.value)}
                </span>
              </div>
            </div>
            <div className="relative">
              <div className="h-10 bg-gray-100 rounded-lg overflow-hidden">
                <div
                  className={`h-full ${stage.color} transition-all duration-500 flex items-center justify-between px-3`}
                  style={{ width: `${stage.percentage}%` }}
                >
                  {stage.percentage > 20 && (
                    <>
                      <span className="text-white text-xs font-medium">
                        {stage.count} deals
                      </span>
                      {index < funnelData.length - 1 && (
                        <SafeIcon icon={LuChevronRight} className="h-4 w-4 text-white" />
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConversionFunnel;